import { url } from '@/axios/api_urls/topRanking'
import { getSearchByLetterListData } from '@/axios/api/consumerProducts'
import brandUrl from '@/axios/api_urls/brandAnalytics'

const api = require('@/axios/request')
import {getDictionary} from '@/axios/api/dictionary'
import utils from '@/utils'
import { getLastestDate } from '@/utils/index.js'

const UPDATE_STATE = 'UPDATE_STATE'
const UPDATE_SUBSTATE = 'UPDATE_SUBSTATE'
const UPDATE_TOP_10_INCI = 'UPDATE_TOP_10_INCI'
const UPDATE_TOP_10_CLAIM = 'UPDATE_TOP_10_CLAIM'
const UPDATE_CLAIM_CHART_DATA = 'UPDATE_CLAIM_CHART_DATA'
const UPDATE_RELATED_FORMULATION = 'UPDATE_RELATED_FORMULATION'
const UPDATE_RELATED_CONCEPT = 'UPDATE_RELATED_CONCEPT'
const UPDATE_TOP_10_PRODUCT = 'UPDATE_TOP_10_PRODUCT'
const UPDATE_PRODUCT_RELATED_FORMULATION = 'UPDATE_PRODUCT_RELATED_FORMULATION'
const UPDATE_PRODUCT_RELATED_CONCEPT = 'UPDATE_PRODUCT_RELATED_CONCEPT'
const UPDATE_TOP_10_BRAND = 'UPDATE_TOP_10_BRAND'
const UPDATE_SEARCHBYLETTERLISTDATA = 'UPDATE_SEARCHBYLETTERLISTDATA'
const UPDATE_SEARCH_CLAIM_LIST = 'UPDATE_SEARCH_CLAIM_LIST'
let { year, quarter } = getLastestDate()
quarter = 'Q' + quarter

const state = {
  year: [],
  skinType: [],
  gender: [],
  age: [],
  range: [],
  category: [],
  currentYear: null,
  province: [],
  claimMatchClaim: [],
  // tab和page
  filter: {
    yearId: year,
    season: quarter,
    goodsMarketCategoryId: '',
    skinId: '',
    sexId: '',
    brandPositionId: '',
    groupId: '',
    pricePositionId: '',
    priceRangeId: '',
    ageId: '',
    provinceId: '',
    searchType: 'Clicks'
  },
  claimTabActive: 'first',
  productTabActive: 'first',
  claimPage: {
    size: 10,
    current: 1,
    total: 0
  },
  productPage: {
    size: 10,
    current: 1,
    total: 0
  },
  // product
  topRankForProducts: [],
  goodFormulationsList: [],
  goodConceptList: [],
  bevolGoodsClaims: [],
  selectedClaims: [],
  claimsLetter: 'A',

  // claim
  topRankForClaims: [],
  claimFormulationsList: [],
  claimConceptList: [],
  // brand
  topRankForBrand: [],
  brandFormulationsList: [],
  brandConceptList: [],
  // group
  topRankForGroup: [],
  groupFormulationsList: [],
  groupConceptList: [],
  brandGroup: [],
  top10IngredientList: [],
  top10ClaimList: [],
  claimChartData: [],
  relatedFormaulationsList: [],
  relatedConceptsList: [],
  top10ProductList: [],
  relatedProductFormaulationsList: [],
  relatedProductConceptsList: [],
  top10BrandList: [],
  searchByLetterListData: [],
  searchedClaimList: [],
}
const getters = {
  year: state => state.year,
  skinType: state => state.skinType,
  gender: state => state.gender,
  category: state => state.category,
  age: state => state.age,
  range: state => state.range,
  currentYear: state => state.currentYear,
  province: state => state.province,
  // tab和page
  filter: state => state.filter,
  claimTabActive: state => state.claimTabActive,
  productTabActive: state => state.productTabActive,
  claimPage: state => state.claimPage,
  productPage: state => state.productPage,
  // product
  topRankForProducts: state => state.topRankForProducts,
  goodFormulationsList: state => state.goodFormulationsList,
  goodConceptList: state => state.goodConceptList,
  bevolGoodsClaims: state => state.bevolGoodsClaims,
  selectedClaims: state => state.selectedClaims,
  claimsLetter: state => state.claimsLetter,
  // claim
  topRankForClaims: state => state.topRankForClaims,
  claimFormulationsList: state => state.claimFormulationsList,
  claimConceptList: state => state.claimConceptList,
  claimMatchClaim: state => state.claimMatchClaim,
  // brand
  topRankForBrand: state => state.topRankForBrand,
  brandFormulationsList: state => state.brandFormulationsList,
  brandConceptList: state => state.brandConceptList,
  // group
  topRankForGroup: state => state.topRankForGroup,
  groupFormulationsList: state => state.groupFormulationsList,
  groupConceptList: state => state.groupConceptList,
  brandGroup: state => state.brandGroup,
  top10IngredientList: state => state.top10IngredientList,
  top10ClaimList: state => state.top10ClaimList,
  claimChartData: state => state.claimChartData.map(v => {
    return {
      ...v,
      percent: Number((v.share * 100).toFixed(2))
    }
  }),
  relatedFormaulationsList: state => state.relatedFormaulationsList.map(v => {
    return {
      ...v,
      coverImg: v.imageSrc,
      desc: v.description
    }
  }).filter((v, i) => i < 10),
  relatedConceptsList: state => state.relatedConceptsList.map(v => {
    return {
      ...v,
      coverImg: v.mainImgSrc,
      title: v.internationalTitle,
      desc: v.internationalDesc
    }
  }).filter((v, i) => i < 10),
  top10ProductList: state => state.top10ProductList,
  relatedProductFormaulationsList: state => state.relatedProductFormaulationsList.map(v => {
    return {
      ...v,
      coverImg: v.imageSrc,
      desc: v.description
    }
  }).filter((v, i) => i < 10),
  relatedProductConceptsList: state => state.relatedProductConceptsList.map(v => {
    return {
      ...v,
      coverImg: v.mainImgSrc,
      title: v.internationalTitle,
      desc: v.internationalDesc
    }
  }).filter((v, i) => i < 10),
  top10BrandList: state => state.top10BrandList,
  searchByLetterListData: state => state.searchByLetterListData,
  searchedClaimList: state => state.searchedClaimList
}
const mutations = {
  [UPDATE_STATE] (state, params) {
    state[params.key] = params.value
  },
  [UPDATE_SUBSTATE] (state, params) {
    state[params.key1][params.key2] = params.value
  },
  resetFilter(state, params){
    state.filter = {
      yearId: state.currentYear,
      season: quarter,
      goodsMarketCategoryId: '',
      skinId: '',
      sexId: '',
      brandPositionId: '',
      groupId: '',
      pricePositionId: '',
      priceRangeId: '',
      ageId: '',
      provinceId: '',
      searchType: 'Clicks'
    }
  },
  updateBrandGroup(state, brandGroup) {
    state.brandGroup = brandGroup
  },
  [UPDATE_TOP_10_INCI] (state, list) {
    state.top10IngredientList = list
  },
  [UPDATE_TOP_10_CLAIM] (state, list) {
    state.top10ClaimList = list
  },
  [UPDATE_CLAIM_CHART_DATA] (state, list) {
    state.claimChartData = list
  },
  [UPDATE_RELATED_FORMULATION] (state, list) {
    state.relatedFormaulationsList = list
  },
  [UPDATE_RELATED_CONCEPT] (state, list) {
    state.relatedConceptsList = list
  },
  [UPDATE_TOP_10_PRODUCT] (state, list) {
    state.top10ProductList = list
  },
  [UPDATE_PRODUCT_RELATED_CONCEPT] (state, list) {
    state.relatedProductConceptsList = list
  },
  [UPDATE_PRODUCT_RELATED_FORMULATION] (state, list) {
    state.relatedProductFormaulationsList = list
  },
  [UPDATE_TOP_10_BRAND] (state, list) {
    state.top10BrandList = list
  },
  [UPDATE_SEARCHBYLETTERLISTDATA] (state, searchByLetterListData) {
    state.searchByLetterListData = searchByLetterListData
  },
  [UPDATE_SEARCH_CLAIM_LIST] (state, searchedClaimList) {
    state.searchedClaimList = searchedClaimList
  }
}
const actions = {
  getYear({state, commit}, payload){
    return getDictionary(600).then(res => {
      const currentYear = res.data.find(item => Number(item.name) === year)
      commit(UPDATE_STATE, {key: 'year', value: res.data || []})
      commit(UPDATE_STATE, {key: 'currentYear', value: currentYear && currentYear.id || null})
      commit(UPDATE_SUBSTATE, {key1: 'filter', key2: 'yearId', value: state.currentYear || ''})
      return res
    })
  },
  getSkinType({commit}, payload){
    getDictionary(53).then(res => {
      commit(UPDATE_STATE, {key: 'skinType', value: res.data || []})
    })
  },
  getGender({commit}, payload){
    getDictionary(50).then(res => {
      commit(UPDATE_STATE, {key: 'gender', value: res.data || []})
    })
  },
  getAge({commit}, payload){
    getDictionary(43).then(res => {
      commit(UPDATE_STATE, {key: 'age', value: res.data || []})
    })
  },
  getRange({commit}, payload){
    getDictionary(220).then(res => {
      commit(UPDATE_STATE, {key: 'range', value: res.data || []})
    })
  },
  getCategory({commit}, payload){
    return api._post(url.category).then(res => {
      commit(UPDATE_STATE, {key: 'category', value: res.data || []})
      return res
    })
  },

  getClaimList({commit}, payload){
    return api._post(url.claimList, {keyword: payload, tname: 'goods'}).then(res => {
      commit(UPDATE_STATE, {key: 'bevolGoodsClaims', value: res.data || []})
    })
  },
  getProvinceList({commit}, payload){
    api._post(url.province).then(res => {
      commit(UPDATE_STATE, {key: 'province', value: res.data || []})
    })
  },
  getTop10Goods({commit}, payload){
    if (payload.yearId === 601 && payload.season === 'Q1') {
      commit(UPDATE_STATE, {key: 'topRankForProducts', value: []})
      return true
    }
    return api._post(url.top10Goods, payload).then(res => {
      commit(UPDATE_STATE, {key: 'topRankForProducts', value: res.data || []})
    })
  },
  getTop10Claim({commit}, payload){
    if (payload.yearId === 601 && payload.season === 'Q1') {
      commit(UPDATE_STATE, {key: 'topRankForClaims', value: []})
      return true
    }
    return api._post(url.top10Claim, payload).then(res => {
      commit(UPDATE_STATE, {key: 'topRankForClaims', value: res.data || []})
      return res
    })
  },
  getGoodRelatedFormulations({commit}, payload){
    if (payload.yearId === 601 && payload.season === 'Q1') {
      commit(UPDATE_STATE, {key: 'goodFormulationsList', value: []})
      return true
    }
    return api._post(url.goodRelatedFormulations, payload).then(res => {
      commit(UPDATE_STATE, {key: 'goodFormulationsList', value: res.data || []})
    })
  },
  getGoodRelatedConcepts({commit}, payload){
    if (payload.yearId === 601 && payload.season === 'Q1') {
      commit(UPDATE_STATE, {key: 'goodConceptList', value: []})
      return true
    }
    return api._post(url.goodRelatedConcepts, payload).then(res => {
      commit(UPDATE_STATE, {key: 'goodConceptList', value: (res && res.data && res.data.listDate) ? res.data.listDate : []})
      return res.data || {}
    })
  },
  getClaimRelatedFormulations({commit}, payload){
    if (payload.yearId === 601 && payload.season === 'Q1') {
      commit(UPDATE_STATE, {key: 'claimFormulationsList', value: []})
      return true
    }
    return api._post(url.claimRelatedFormulations, payload).then(res => {
      commit(UPDATE_STATE, {key: 'claimFormulationsList', value: res.data || []})
    })
  },
  getClaimRelatedConcepts({commit}, payload){
    if (payload.yearId === 601 && payload.season === 'Q1') {
      commit(UPDATE_STATE, {key: 'claimConceptList', value: []})
      return true
    }
    return api._post(url.claimRelatedConcepts, payload).then(res => {
      commit(UPDATE_STATE, {key: 'claimConceptList', value: (res && res.data && res.data.listDate) ? res.data.listDate : []})
      return res.data || {}
    })
  },
  getClaimMatchClaim({commit}, payload){
    return api._post(url.claimMatchClaim, payload).then(res => {
      commit(UPDATE_STATE, {key: 'claimMatchClaim', value: res.data || []})
    })
  },
  getTop10Brand({commit}, payload){
    if (payload.yearId === 601 && payload.season === 'Q1') {
      commit(UPDATE_STATE, {key: 'topRankForBrand', value: []})
      return true
    }
    return api._post(url.top10Brand, payload).then(res => {
      commit(UPDATE_STATE, {key: 'topRankForBrand', value: res.data || []})
    })
  },
  getGroup({commit}, payload){
    return api._post(brandUrl.GET_GROUP_lIST, {keyword: payload})
  },
  async getNewDataDateApi ({commit}) {
    try {
      const { data: res } = await api._post(url.getNewDataDate)
      return res
    } catch (e) {}
  },
  async getTop10IngredientApi ({commit}, params) {
    try {
      const { data: res } = await api._post(url.getTop10Ingredient, params)
      commit(UPDATE_TOP_10_INCI, res || [])
      return res
    } catch (e) {}
  },
  async getTop10ClaimApi ({commit}, params) {
    try {
      const { data: res } = await api._post(url.top10Claim, params)
      commit(UPDATE_TOP_10_CLAIM, res || [])
      return res
    } catch (e) {}
  },
  async getClaimMatchClaimApi ({commit}, params) {
    try {
      const { data: res } = await api._post(url.claimMatchClaim, {
        ...params,
        requestName: 'getClaimMatchClaimApi'
      })
      commit(UPDATE_CLAIM_CHART_DATA, res || [])
      return res
    } catch (e) {}
  },
  async getClaimRelatedFormulationsApi ({commit}, params) {
    try {
      const { data: res } = await api._post(url.claimRelatedFormulations, params)
      commit(UPDATE_RELATED_FORMULATION, res || [])
      return res
    } catch (e) {}
  },
  async getClaimRelatedConceptsApi ({commit}, params) {
    try {
      const { data: res } = await api._post(url.claimRelatedConcepts, params)
      commit(UPDATE_RELATED_CONCEPT, res || [])
      return res
    } catch (e) {}
  },
  async getProductRelatedFormulationsApi ({commit}, params) {
    try {
      const { data: res } = await api._post(url.claimRelatedFormulations, params)
      commit(UPDATE_PRODUCT_RELATED_FORMULATION, res || [])
      return res
    } catch (e) {}
  },
  async getProductRelatedConceptsApi ({commit}, params) {
    try {
      const { data: res } = await api._post(url.claimRelatedConcepts, params)
      commit(UPDATE_PRODUCT_RELATED_CONCEPT, res || [])
      return res
    } catch (e) {}
  },
  async getTop10GoodsApi ({commit}, params) {
    try {
      const { data: res } = await api._post(url.top10Goods, params)
      commit(UPDATE_TOP_10_PRODUCT, res || [])
      return res
    } catch (e) {}
  },
  async getTop10BrandApi ({commit}, params) {
    try {
      const { data: res } = await api._post(url.top10Brand, params)
      commit(UPDATE_TOP_10_BRAND, res || [])
      return res
    } catch (e) {}
  },
  async getSearchByLetterListDataApi ({ commit }, params) {
    try {
      let { data: res } = await getSearchByLetterListData({ ...params, tname: 'goods' })
      commit(UPDATE_SEARCHBYLETTERLISTDATA, res)
    } catch (e) { }
  },
  // 获取宣称
  async searchClaimDataByTitleApi ({ commit }, params) {
    try {
      const { data: res } = await getSearchByLetterListData({title: params, tname: 'goods'})
      commit(UPDATE_SEARCH_CLAIM_LIST, (res || []).map(v => {
        return {
          id: v.id,
          title: v.title
        }
      }))
    } catch (e) {
      commit(UPDATE_SEARCH_CLAIM_LIST, [])
    }
  },
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/topRanking.js